import { MouseEventHandler } from "react";

import cx from "@hsl/core/utils/cx";

interface Props {
    children: React.ReactNode;
    className?: string;
    onClick?: MouseEventHandler;
}

export const FundCardTitle = ({ children, className, onClick }: Props) => (
    <h3
        className={cx(
            "text-core-blue text-left text-lg font-medium leading-tight",
            className,
        )}
        onClick={onClick}
    >
        {children}
    </h3>
);
